import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";

const finishRegistration = {
  ...getI18nJsonProp(base, "finishRegistration"),
};

export default finishRegistration;
